import { render, staticRenderFns } from "./GuestbookView.vue?vue&type=template&id=0067bb5c&scoped=true"
import script from "./GuestbookView.ts?vue&type=script&lang=ts&external"
export * from "./GuestbookView.ts?vue&type=script&lang=ts&external"
import style0 from "./GuestbookView.scss?vue&type=style&index=0&id=0067bb5c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0067bb5c",
  null
  
)

export default component.exports